import React, { useEffect, useRef, useState } from "react";
import { Image, Radio, Space } from "antd";
/** @jsxImportSource @emotion/react */
import tw from "twin.macro";
import like from "../../../assets/svg/like.svg";
import { ReactComponent as Liked } from "../../../assets/svg/liked.svg";
import likeOutlined from "../../../assets/svg/like_outlined.svg";
import share from "../../../assets/svg/share.svg";
import sprayIcon from "../../../assets/svg/spray.svg";

import comment from "../../../assets/svg/comment.svg";
import inner from "../../../assets/images/inner_tl1.png";
import { isEmpty, Toast } from "../../../lib/helpers/helpers";
import { Loading } from "../../Loading/Loading";
import {
	CardTimeline,
	CarouselItemNumber,
	SprayContainer,
	SprayContent,
	SpraySelectContainer,
} from "./component";
import {
	useFetchTimelineDetail,
	usePostAction,
} from "../../../redux/api/Timeline";
import errorHandler from "../../../redux/actions/errorHandler";
import { Link } from "react-router-dom";
import Carousel from "react-multi-carousel";
import PinInput from "../../PinInput/PinInput";
import { useSprayTimeline } from "../../../redux/api/Transaction";
import Auth from "../../../lib/middleware/auth";
import PinSetup from "../../SetupWallet/PinSetup";

const TimelineComp = (props) => {
	const { comments, loading, timelineData } = props;
	const userData = Auth.getUser();
	const { is_wallet_set } = userData;
	const responsiveSlide = {
		desktop: {
			breakpoint: {
				max: 3000,
				min: 1024,
			},
			items: 1,
		},
		mobile: {
			breakpoint: {
				max: 464,
				min: 0,
			},
			items: 1,
		},
		tablet: {
			breakpoint: {
				max: 1024,
				min: 464,
			},
			items: 1,
		},
	};
	const [currentSlide, setCurrentSlide] = useState(1);
	const [timeline, setTimeline] = useState(timelineData);
	const [pinVisible, setPinVisible] = useState(false);
	const oneRef = useRef();
	const twoRef = useRef();
	const fiveRef = useRef();
	const oneThousandRef = useRef();
	const [note, setNote] = useState("");
	const [show, setShow] = useState(false);
	const [isLiked, setIsLiked] = useState(timelineData?.has_liked);
	const [showLike, setShowLike] = useState(false);
	const [spray, setSpray] = useState(false);
	const [sprayCouple, setSprayCouple] = useState(false);
	const [pin, setPin] = useState("");
	const [amount, setAmount] = useState(0);
	const [isTransactionPin, setTransactionPin] = useState(false);
	const { wedding_post_media } = !isEmpty(timeline) ? timeline : [];

	const { data: timelineDt, refetch } = useFetchTimelineDetail({
		weddingId: timelineData?.weddingId,
		postId: timelineData?.id,
		comments_paginate: 15,
	});
	const { mutateAsync: handlePostReaction } = usePostAction();
	const { mutateAsync: handleSpray, isloading } = useSprayTimeline();

	const handleSprayTimeline = async () => {
		const data = {
			weddingId: timeline.weddingId,
			postId: timeline.id,
			walletPin: pin,
			origin: "wedding_post",
			currencyCode: "NGN",
			amount: amount,
			sprayCouple: sprayCouple,
			...(!sprayCouple && { receiverId: timeline.user.id }),
		};
		try {
			const res = await handleSpray(data);
			console.log("handle like res", res);
			const { hasError, errors } = res;
			if (hasError) {
				return errorHandler(errors);
			}
			Toast.fire({ icon: "success", title: res.message });
			setAmount(0);
			setShow(false);
			setPin("");
		} catch (err) {
			console.log("the spray error", err);
		}
	};

	const handleReaction = async () => {
		const data = {
			weddingId: timeline.weddingId,
			postId: timeline.id,
			action: timeline.has_liked ? "unlike" : "like",
		};
		try {
			const res = await handlePostReaction(data);
			console.log("handle like res", res);
			const { hasError, errors } = res;
			if (hasError) {
				return errorHandler(errors);
			}
			refetch();
		} catch (err) {
			console.log("the pay error", err);
		}
	};

	const handleAmount = (val) => {
		setAmount(amount + val);
		setSpray(true);
	};

	// console.log(
	// 	// 	"spray amount========>>>>>>>\n",
	// 	// 	amount,
	// 	// "\nTimeline data============>>>>>>\n",
	// 	// timeline
	// 	// "User data============>>>>>>\n",
	// 	// userData
	// );
	useEffect(() => {
		if (isEmpty(timelineDt)) {
			return;
		}
		const { hasError } = timelineDt;
		if (hasError) {
			return;
		}
		setTimeline(timelineDt.data);
	}, [timelineDt]);

	useEffect(() => {
		if (!showLike) {
			return;
		}
		setTimeout(() => {
			setShowLike(false);
		}, 1500);
	}, [showLike]);

	useEffect(() => {
		if (isEmpty(timeline.has_liked)) {
			return;
		}
		setIsLiked(timeline.has_liked);
	}, [timeline?.has_liked]);

	return (
		<>
			<CardTimeline large={props.large}>
				{loading || isloading ? (
					<Loading />
				) : (
					<Link
						to={{
							pathname: `/timeline/post/${timelineData.id}`,
							state: { timeline },
						}}
						tw="w-full h-auto">
						<Carousel
							additionalTransfrom={0}
							afterChange={function (previousSlide, _ref) {
								var currentSlide = _ref.currentSlide;
								setCurrentSlide(currentSlide + 1);
							}}
							arrows={false}
							autoPlaySpeed={3000}
							centerMode={false}
							className=""
							containerClass="carousel-container"
							dotListClass=""
							draggable={true}
							minimumTouchDrag={30}
							keyBoardControl={true}
							focusOnSelect={false}
							itemClass="item-container"
							responsive={responsiveSlide}
							showDots={false}
							sliderClass=""
							slidesToSlide={1}
							swipeable>
							{isEmpty(wedding_post_media) ? (
								<h3 tw="h-full w-full text-white p-4 font-bold text-lg text-center">
									{timeline?.post_text}
								</h3>
							) : (
								wedding_post_media?.map((img, i) => {
									return (
										<Image
											key={i}
											preview={false}
											src={img.media_url}
											alt=""
											placeholder={
												<Image
													preview={false}
													src={img.media_url_min}
												/>
											}
										/>
									);
								})
							)}
						</Carousel>
					</Link>
				)}

				{showLike && (
					<Liked style={{ zIndex: "10000" }} tw="absolute" />
				)}

				{spray && (
					<SprayContainer
						style={{
							overflow: "hidden",
							zIndex: "100000000",
							height: props.large ? "180px" : "140px",
							width: props.large ? "180px" : "140px",
						}}
						tw="absolute hover:(shadow-lg cursor-pointer) transition-all ease-in-out delay-1000">
						<SprayContent
							onClick={() => {
								setPinVisible(true);
								setSpray(false);
							}}
							tw="text-white gap-1 hover:(text-red-100 shadow-md)"
							style={{
								zIndex: "100000000",
								height: props.large ? "160px" : "120px",
								width: props.large ? "160px" : "120px",
								padding: props.large ? "1rem" : "0.75rem",
							}}>
							<span
								style={{
									fontSize: props.large
										? "1.2rem"
										: "0.75rem",
								}}
								className="sprayCurrency"
								tw="uppercase font-semibold! flex h-full items-center mt-8">
								₦
							</span>
							<div
								tw="flex flex-col gap-0 h-full w-full"
								style={{
									flex: "1",
								}}>
								<span
									style={{
										fontSize: props.large
											? "1.5rem"
											: "1.25rem",
									}}
									className="sprayTitle"
									tw="h-full flex items-end justify-start font-light">
									SPRAY
								</span>
								<span
									style={{
										fontSize: props.large
											? "2.2rem"
											: "1.875rem",
										marginTop: "-8px",
									}}
									className="sprayAmount"
									tw="h-full flex items-start justify-start font-bold">
									{amount}
								</span>
							</div>
						</SprayContent>
					</SprayContainer>
				)}

				{show && userData?.weddingId !== timeline.weddingId && (
					<SpraySelectContainer tw="absolute top-10 right-2 px-1 py-1">
						<h4 tw="text-right font-bold text-white mb-0!">
							Spray
						</h4>
						<Radio.Group
							onChange={({ target: { value } }) => {
								setSprayCouple(value);
							}}
							value={sprayCouple}>
							<Space direction="vertical" align="end">
								<Radio value={true}>Couple</Radio>
								<Radio defaultChecked value={false}>
									{timeline?.user?.firstname}{" "}
									{timeline?.user?.lastname}
								</Radio>
							</Space>
						</Radio.Group>
					</SpraySelectContainer>
				)}

				<span tw="absolute top-2 left-2 rounded-full">
					<Image
						preview={false}
						src={timeline?.user?.profile_pic_url || inner}
						alt=""
						width="auto"
						tw="h-8 w-8 rounded-full border border-solid border-white"
					/>
				</span>
				{timeline?.wedding_post_media.length > 0 && (
					<CarouselItemNumber tw="absolute top-2 right-2 rounded-full bg-black px-2 py-1">
						{currentSlide}/{timeline?.wedding_post_media.length}
					</CarouselItemNumber>
				)}
				<span
					tw="absolute bottom-4 left-2 rounded-md px-3 py-3 inline-flex flex-nowrap items-center space-x-3"
					className="midFadedBg">
					<span tw="inline-flex flex-nowrap items-center">
						<Image
							preview={false}
							src={isLiked ? like : likeOutlined}
							alt=""
							width={20}
							height={20}
							tw="hover:(cursor-pointer)"
							onClick={() => {
								handleReaction();
								setShowLike(!timeline.has_liked ? true : false);
							}}
						/>
						{/* <Like color={timeline.has_liked ? "red" : ""} /> */}
						<span tw="ml-1 text-white text-xs font-semibold opacity-50">
							{timeline.likes_count}
						</span>
					</span>

					<Link
						to={{
							pathname: `/timeline/post/${timeline.id}`,
							state: { timeline, focus: true },
						}}
						tw="flex">
						<span
							tw="inline-flex flex-nowrap items-center"
							onClick={props.handleComment}>
							<Image
								preview={false}
								src={comment}
								alt=""
								width={16}
								height={16}
							/>
							<span tw="ml-1 text-white text-xs font-semibold opacity-50">
								{comments}
							</span>
						</span>
					</Link>

					<span tw="inline-flex flex-nowrap items-center">
						<Image
							preview={false}
							src={share}
							alt=""
							width={16}
							height={16}
						/>
					</span>
				</span>
				{!isEmpty(wedding_post_media) && (
					<span tw="absolute bottom-4 right-2">
						<span tw="relative">
							<button
								onClick={() => {
									setNote(oneRef.current?.innerText);
									handleAmount(100);
								}}
								ref={oneRef}
								tw="bg-appTextDark px-1.5 py-2 text-center text-white rounded-full absolute font-bold border-none transition-all ease-in-out delay-100"
								css={[
									{
										fontSize: "0.5rem",
										right: "3.75rem",
										bottom: "-0.75rem",
									},
									note === "100" && tw`bg-appPink`,
									show ? tw`visible` : tw`invisible`,
								]}>
								100
							</button>
							<button
								onClick={() => {
									setNote(twoRef.current?.innerText);
									handleAmount(200);
								}}
								ref={twoRef}
								tw="bg-appTextDark px-1.5 py-2 text-center text-white rounded-full absolute font-bold border-none transition-all ease-in-out delay-200"
								css={[
									{
										fontSize: "0.5rem",
										right: "3.5rem",
										bottom: "1.275rem",
									},
									note === "200" && tw`bg-appPink`,
									show ? tw`visible` : tw`invisible`,
								]}>
								200
							</button>
							<button
								onClick={() => {
									setNote(fiveRef.current?.innerText);
									handleAmount(500);
								}}
								ref={fiveRef}
								tw="bg-appTextDark px-1.5 py-2 text-center text-white rounded-full absolute font-bold border-none transition-all ease-in-out delay-300"
								css={[
									{
										fontSize: "0.5rem",
										right: "2.25rem",
										bottom: "2.875rem",
									},
									note === "500" && tw`bg-appPink`,
									show ? tw`visible` : tw`invisible`,
								]}>
								500
							</button>
							<button
								onClick={() => {
									setNote(oneThousandRef.current?.innerText);
									handleAmount(1000);
								}}
								ref={oneThousandRef}
								tw="bg-appTextDark px-1.5 py-2.5 text-center text-white rounded-full absolute font-bold border-none transition-all ease-in-out delay-500"
								css={[
									{
										fontSize: "0.5rem",
										right: "0px",
										bottom: "3.2rem",
									},
									note === "1000" && tw`bg-appPink`,
									show ? tw`visible` : tw`invisible`,
								]}>
								1000
							</button>
							{/*spray button  */}
							<button
								tw="rounded-md px-3 py-3 inline-flex flex-nowrap items-center border-none"
								className="midFadedBg"
								onClick={() => {
									setShow(!show);
									setSpray(false);
									setAmount(0);
									setNote("");
								}}>
								<span tw="inline-flex flex-nowrap items-center">
									<Image
										preview={false}
										src={sprayIcon}
										alt=""
										width={25}
										height={25}
									/>
								</span>
							</button>
						</span>
					</span>
				)}
			</CardTimeline>
			<PinInput
				pin={pin}
				title={
					<h4 tw="text-appTextFaded">
						You are about to spray{" "}
						{sprayCouple
							? `#${timeline?.wedding?.hashtag}`
							: timeline?.user?.firstname}{" "}
						the sum of N{amount}
					</h4>
				}
				isVisible={pinVisible}
				goBack={() => {
					setPinVisible(false);
					setPin("");
					setSpray(true);
				}}
				setPin={(v) => setPin(v)}
				continueTask={() => {
					setPinVisible(false);
					is_wallet_set
						? handleSprayTimeline()
						: setTransactionPin(true);
				}}
			/>
			<PinSetup pinData={pin} />
			<PinInput
				pin={pin}
				title={"Keep your account safe, set a PIN for all transactions"}
				confirmPinInput
				isVisible={isTransactionPin}
				setPin={setPin}
				goBack={() => setTransactionPin(false)}
				continueTask={() => setTransactionPin(false)}
			/>
		</>
	);
};

export default TimelineComp;
